const painPoints = [
  {
    icon: "ri-compass-3-line",
    title: "Something in your life is ready to move",
    body:
      "You can sense it—something is shifting, even if you can't fully see where it's leading yet. The next step isn't about forcing clarity, but allowing it to unfold in a way that is safe.",
  },
  {
    icon: "ri-leaf-line",
    title: "The path you were on is no longer yours to follow",
    body:
      "Life has shifted. A role, a rhythm, or a version of you has run its course. This isn't a loss of direction; it's an invitation to choose again.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Your life makes sense but something about it doesn't feel right anymore",
    body:
      "From the outside, everything may still look intact. But internally, something is asking for more—more truth, more depth, more integrity in how you move through life.",
  },
  {
    icon: "ri-anchor-line",
    title: "You're navigating something that has shaken your world",
    body:
      "A diagnosis, a loss, an unexpected turn — sometimes life asks more of us than we feel equipped to give. You don't have to find the answers alone. You just need a steady place to land.",
  },
];

export default function WhoItsFor() {
  return (
    <section id="for-you" className="bg-white py-28 md:py-36 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Label */}
        <p className="font-sans text-xs tracking-widest2 uppercase text-ink mb-6 text-center">
          Who This Is For
        </p>

        <h2 className="font-serif text-4xl md:text-5xl font-light text-ink text-center leading-snug mb-6 max-w-3xl mx-auto">
          You may feel lost.<br />
          <em className="font-medium">But you&apos;re ready.</em>
        </h2>

        <p className="font-sans text-base font-light text-ink text-center leading-relaxed max-w-xl mx-auto mb-20">
          You don&apos;t need all the answers to begin. You just need one honest conversation.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {painPoints.map((point) => (
            <div key={point.title} className="flex flex-col">
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className={`${point.icon} text-2xl text-ink`}></i>
              </div>
              <div className="w-8 h-px bg-sand mb-5" />
              <h3 className="font-serif text-2xl font-medium text-ink mb-3">{point.title}</h3>
              <p className="font-sans text-sm font-light text-ink leading-relaxed">{point.body}</p>
            </div>
          ))}
        </div>

        {/* Divider quote */}
        <div className="mt-24 text-center">
          <blockquote className="font-serif text-2xl md:text-3xl font-light italic text-ink max-w-2xl mx-auto leading-relaxed">
            &ldquo;The most powerful move you can make is the one that comes from within.&rdquo;
          </blockquote>
          <p className="font-sans text-xs tracking-widest2 uppercase text-ink/40 mt-5">— Krystal Danielle</p>
        </div>
      </div>
    </section>
  );
}
